import axios from '@/utils/axios';

export default {
  getCharset() {
    return axios.get(`/charset`,);
  },
};
